// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.helper-text-define {
  font-size: 16px;
  margin: 0px 0px 24px 0px;
}

.grade-btn-container-define {
  margin: 8px 0px 20px 0px;
  flex-wrap: wrap;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.grade-btn-container-define .define-btn-wrapper {
  position: relative;
}
.grade-btn-container-define .completed-status-define {
  position: absolute;
  right: -10px;
  top: -10px;
}
.grade-btn-container-define .not-applicable-circle {
  border-radius: 50px;
  background-color: white;
  border: 2px solid #444343;
  color: #444343;
  font-size: 12px;
  font-weight: 500;
  padding: 4px;
  position: absolute;
  right: -10px;
  top: -10px;
}

.subject-name {
  background-color: #636161;
  border: 1px solid #808080;
  border-radius: 3px;
  color: white;
  display: flex;
  font-size: 1.3rem;
  font-weight: 600;
  justify-content: space-between;
  margin-top: 12px;
  padding: 8px 24px;
  width: 100%;
}

.selected-subject-name {
  background-color: white;
  border: 3px solid #808080;
  border-bottom: none;
  border-radius: 3px 3px 0px 0px;
  color: #0669B3;
  display: flex;
  font-size: 1.3rem;
  font-weight: 600;
  justify-content: space-between;
  margin-top: 12px;
  padding: 8px 24px;
  width: 100%;
}

.complete-centered-tag {
  align-items: center;
  display: flex;
}

.secondary-text-define {
  border-radius: 20px;
  background: white;
  color: #CB321A;
  font-size: 14px;
  font-style: italic;
  font-weight: 500;
  margin-right: 24px;
  padding: 0px 8px;
}

.complete-text-green {
  color: green;
}

.open-content-area {
  background-color: white;
  border-radius: 0px 0px 3px 3px;
  border: 3px solid #808080;
  border-top: none;
  padding: 0px 24px 12px;
}
.open-content-area .standard-row {
  border-bottom: 1px solid #D1D3D4;
  display: flex;
  justify-content: space-between;
  padding: 16px;
}
.open-content-area .std {
  background-color: rgba(192, 222, 240, 0.3);
}
.open-content-area .subject-name-header {
  font-size: 1.2rem;
  font-weight: 650;
  color: #0669B3;
}
.open-content-area .no-reportable-content-message {
  color: #444343;
  font-weight: 500;
}
.open-content-area .standard-name-define {
  font-size: 18px;
  font-weight: 600;
  margin-left: 12px;
}
.open-content-area .gle-name {
  font-size: 16px;
  font-weight: 500;
}
.open-content-area .eo-name {
  font-size: 14px;
  font-weight: 400;
}
.open-content-area .eoChild-name {
  font-size: 14px;
  font-weight: 400;
}
.open-content-area .not-reportable-wrapper {
  display: flex;
  align-items: center;
}
.open-content-area .header-define-table {
  position: sticky;
  background-color: white;
  top: 0px;
  z-index: 1;
}
.open-content-area .header-define-table .header {
  font-size: 1.1rem;
  font-weight: 600;
  margin-left: 16px;
  color: #0669B3;
}
.open-content-area .standard-check-container {
  width: 250px;
  display: flex;
  justify-content: flex-end;
}
.open-content-area .standard-check-container input {
  margin-left: 36px;
}
.open-content-area .standard-check-container .dash {
  margin-left: 32px;
}
.open-content-area .define-complete-check-btn {
  border-radius: 5px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  align-items: center;
  background-color: white;
  border: 1px solid #0669B3;
  color: #0669B3;
  cursor: pointer;
  display: flex;
  justify-content: center;
  min-width: 160px;
  padding: 4px 8px;
}
.open-content-area .define-complete-check-btn input {
  margin-right: 12px;
  transform: scale(1.2);
}
.open-content-area .define-complete-check-btn:hover {
  transform: scale(1.035);
}
.open-content-area .disabled-save-and-complete {
  cursor: not-allowed;
  opacity: 0.5;
}
.open-content-area .define-complete-check-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-left: 10px;
}
.open-content-area .profile-button-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin: 24px 0px;
}
.open-content-area .profile-button-container .validation-error-banner {
  width: 100%;
  margin-bottom: 12px;
  padding: 8px 12px;
  background-color: #fff3f3;
  border: 1px solid red;
  border-radius: 4px;
  color: darkred;
  font-size: 0.9rem;
}
.open-content-area .profile-button-container .validation-warning-banner {
  width: 100%;
  margin-bottom: 12px;
  padding: 8px 12px;
  background-color: #fffbf0;
  border: 1px solid #e6a817;
  border-radius: 4px;
  color: #7a4f00;
  font-size: 0.9rem;
}

.unrelease-dialog-title {
  color: #CB321A;
}

.unrelease-dialog-imp-text {
  font-weight: 500;
  text-decoration: underline;
}

.success-section-wrapper {
  margin-bottom: 16px;
}
.success-section-wrapper .success-title-text {
  color: darkgreen;
  font-weight: 700;
}
.success-section-wrapper .success-count-text {
  color: black;
}

.attention-required-title {
  font-weight: 700;
  margin-bottom: 8px;
}

.attention-required-text {
  color: darkred;
}

.affected-teachers-title {
  color: black;
  font-weight: 600;
  margin-top: 12px;
}

.affected-teachers-list {
  color: black;
  font-size: 0.9rem;
  margin-top: 4px;
}

.affected-teacher-bullet {
  display: -webkit-box;
  font-size: 0.8rem;
  line-clamp: 2;
  line-height: 1.2rem;
  max-height: 2.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.remove-dialog-imp-wrapper {
  background-color: #FEBF31;
  border: 2px solid black;
  border-radius: 5px;
  color: black;
  padding: 8px 12px;
}

.remove-dialog-imp-text {
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/DefineReportingPeriods.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AANA;EACE,eAAA;EACA,wBAAA;AASF;;AANA;EACE,wBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;AASF;AAPE;EACE,kBAAA;AASJ;AANE;EACE,kBAAA;EACA,YAAA;EACA,UAAA;AAQJ;AALE;ECvBE,mBDwBsB;EACtB,uBAAA;EACA,yBAAA;EACA,cDEK;ECDL,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;AAOJ;;AAHA;EACE,yBDVM;ECWN,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AAMF;;AAHA;EACE,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,8BAAA;EACA,cD1BW;EC2BX,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AAMF;;AAHA;EACE,mBAAA;EACA,aAAA;AAMF;;AAHA;ECvEI,mBDwEoB;EACtB,iBAAA;EACA,cD3DI;EC4DJ,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAMF;;AAHA;EACE,YAAA;AAMF;;AAHA;EACE,uBAAA;EACA,8BAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;AAMF;AAJE;EACE,gCAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;AAMJ;AAHE;EACE,0CAAA;AAKJ;AAFE;EACE,iBAAA;EACA,gBAAA;EACA,cD7ES;ACiFb;AADE;EACE,cDlFK;ECmFL,gBAAA;AAGJ;AAAE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAEJ;AACE;EACE,eAAA;EACA,gBAAA;AACJ;AAEE;EACE,eAAA;EACA,gBAAA;AAAJ;AAGE;EACE,eAAA;EACA,gBAAA;AADJ;AAIE;EACE,aAAA;EACA,mBAAA;AAFJ;AAKE;EACE,gBAAA;EACA,uBAAA;EACA,QAAA;EACA,UAAA;AAHJ;AAKI;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cDzHO;ACsHb;AAOE;EACE,YAAA;EACA,aAAA;EACA,yBAAA;AALJ;AAOI;EACE,iBAAA;AALN;AAQI;EACE,iBAAA;AANN;AAUE;ECzKE,kBD0KsB;ECrJtB,2CAAA;EDuJA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cDjJS;ECkJT,eAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AARJ;AAUI;EACE,kBAAA;EACA,qBAAA;AARN;AAWI;EACE,uBAAA;AATN;AAaE;EACE,mBAAA;EACA,YAAA;AAXJ;AAcE;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;AAZJ;AAeE;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AAbJ;AAeI;EACE,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AAbN;AAgBI;EACE,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AAdN;;AAmBA;EACE,cD3NI;AC2MN;;AAmBA;EACE,gBAAA;EACA,0BAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;AAkBE;EACE,gBAAA;EACA,gBAAA;AAhBJ;AAmBE;EACE,YAAA;AAjBJ;;AAqBA;EACE,gBAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,cAAA;AAlBF;;AAqBA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,YAAA;EACA,iBAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,oBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EAEA,qBAAA;EACA,4BAAA;AAnBF;;AAsBA;EACE,yBD9QU;EC+QV,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAnBF;;AAsBA;EACE,gBAAA;AAnBF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n\n.helper-text-define {\n  font-size: 16px;\n  margin: 0px 0px 24px 0px;\n}\n\n.grade-btn-container-define {\n  margin: 8px 0px 20px 0px;\n  flex-wrap: wrap;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n\n  .define-btn-wrapper {\n    position: relative;\n  }\n\n  .completed-status-define {\n    position: absolute;\n    right: -10px;\n    top: -10px;\n  }\n\n  .not-applicable-circle {\n    @include borderRadius(50px);\n    background-color: white;\n    border: 2px solid $grey4a;\n    color: $grey4a;\n    font-size: 12px;\n    font-weight: 500;\n    padding: 4px;\n    position: absolute;\n    right: -10px;\n    top: -10px;\n  }\n}\n\n.subject-name {\n  background-color: $grey4;\n  border: 1px solid $grey3;\n  border-radius: 3px;\n  color: white;\n  display: flex;\n  font-size: 1.3rem;\n  font-weight: 600;\n  justify-content: space-between;\n  margin-top: 12px;\n  padding: 8px 24px;\n  width: 100%;\n}\n\n.selected-subject-name {\n  background-color: white;\n  border: 3px solid $grey3;\n  border-bottom: none;\n  border-radius: 3px 3px 0px 0px;\n  color: $pearl-blue;\n  display: flex;\n  font-size: 1.3rem;\n  font-weight: 600;\n  justify-content: space-between;\n  margin-top: 12px;\n  padding: 8px 24px;\n  width: 100%;\n}\n\n.complete-centered-tag {\n  align-items: center;\n  display: flex;\n}\n\n.secondary-text-define {\n  @include borderRadius(20px);\n  background: white;\n  color: $red;\n  font-size: 14px;\n  font-style: italic;\n  font-weight: 500;\n  margin-right: 24px;\n  padding: 0px 8px;\n}\n\n.complete-text-green {\n  color: green;\n}\n\n.open-content-area {\n  background-color: white;\n  border-radius: 0px 0px 3px 3px;\n  border: 3px solid $grey3;\n  border-top: none;\n  padding: 0px 24px 12px;\n\n  .standard-row {\n    border-bottom: 1px solid $grey1;\n    display: flex;\n    justify-content: space-between;\n    padding: 16px;\n  }\n\n  .std {\n    background-color: rgba(192, 222, 240, 0.3);\n  }\n\n  .subject-name-header {\n    font-size: 1.2rem;\n    font-weight: 650;\n    color: $pearl-blue;\n  }\n\n  .no-reportable-content-message {\n    color: $grey4a;\n    font-weight: 500;\n  }\n\n  .standard-name-define {\n    font-size: 18px;\n    font-weight: 600;\n    margin-left: 12px;\n  }\n\n  .gle-name {\n    font-size: 16px;\n    font-weight: 500;\n  }\n\n  .eo-name {\n    font-size: 14px;\n    font-weight: 400;\n  }\n\n  .eoChild-name {\n    font-size: 14px;\n    font-weight: 400;\n  }\n\n  .not-reportable-wrapper {\n    display: flex;\n    align-items: center;\n  }\n\n  .header-define-table {\n    position: sticky;\n    background-color: white;\n    top: 0px;\n    z-index: 1;\n\n    .header {\n      font-size: 1.1rem;\n      font-weight: 600;\n      margin-left: 16px;\n      color: $pearl-blue;\n    }\n  }\n\n  .standard-check-container {\n    width: 250px;\n    display: flex;\n    justify-content: flex-end;\n\n    input {\n      margin-left: 36px;\n    }\n\n    .dash {\n      margin-left: 32px;\n    }\n  }\n\n  .define-complete-check-btn {\n    @include borderRadius(5px);\n    @include shadow();\n    align-items: center;\n    background-color: white;\n    border: 1px solid $pearl-blue;\n    color: $pearl-blue;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    min-width: 160px;\n    padding: 4px 8px;\n\n    input {\n      margin-right: 12px;\n      transform: scale(1.2)\n    }\n\n    &:hover {\n      transform: scale(1.035);\n    }\n  }\n\n  .disabled-save-and-complete {\n    cursor: not-allowed;\n    opacity: 0.5;\n  }\n\n  .define-complete-check-wrapper {\n    display: flex;\n    justify-content: flex-end;\n    margin-left: 10px;\n  }\n\n  .profile-button-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    margin: 24px 0px;\n\n    .validation-error-banner {\n      width: 100%;\n      margin-bottom: 12px;\n      padding: 8px 12px;\n      background-color: #fff3f3;\n      border: 1px solid red;\n      border-radius: 4px;\n      color: darkred;\n      font-size: 0.9rem;\n    }\n\n    .validation-warning-banner {\n      width: 100%;\n      margin-bottom: 12px;\n      padding: 8px 12px;\n      background-color: #fffbf0;\n      border: 1px solid #e6a817;\n      border-radius: 4px;\n      color: #7a4f00;\n      font-size: 0.9rem;\n    }\n  }\n}\n\n.unrelease-dialog-title {\n  color: $red;\n}\n\n.unrelease-dialog-imp-text {\n  font-weight: 500;\n  text-decoration: underline;\n}\n\n.success-section-wrapper {\n  margin-bottom: 16px;\n\n  .success-title-text {\n    color: darkgreen;\n    font-weight: 700;\n  }\n\n  .success-count-text {\n    color: black;\n  }\n}\n\n.attention-required-title {\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n\n.attention-required-text {\n  color: darkred;\n}\n\n.affected-teachers-title {\n  color: black;\n  font-weight: 600;\n  margin-top: 12px;\n}\n\n.affected-teachers-list {\n  color: black;\n  font-size: 0.9rem;\n  margin-top: 4px;\n}\n\n.affected-teacher-bullet {\n  display: -webkit-box;\n  font-size: 0.8rem;\n  line-clamp: 2;\n  line-height: 1.2rem;\n  max-height: 2.4rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.remove-dialog-imp-wrapper {\n  background-color: $important;\n  border: 2px solid black;\n  border-radius: 5px;\n  color: black;\n  padding: 8px 12px\n}\n\n.remove-dialog-imp-text {\n  font-weight: 500;\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
